import { render, staticRenderFns } from "./gst-reports.vue?vue&type=template&id=6b800ae0&scoped=true"
import script from "./gst-reports.vue?vue&type=script&lang=js"
export * from "./gst-reports.vue?vue&type=script&lang=js"
import style0 from "./gst-reports.vue?vue&type=style&index=0&id=6b800ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b800ae0",
  null
  
)

export default component.exports